// Components==============
import { faCheck, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/UI/Avatar/Avatar';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './ReflectionAvatar.module.scss';
// =========================

type Props = {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  reflectionComplete?: boolean;
  active?: boolean;
  user: UserEntity;
  canDelete?: boolean;
  withMargin?: boolean;
};

export default function ReflectionAvatar({
  onClick,
  reflectionComplete,
  active,
  user,
  canDelete,
  withMargin,
}: Props) {
  return (
    <Tooltip content={`${user.first_name} ${user.last_name}`} noPointer>
      <div
        onClick={onClick}
        style={{
          cursor: onClick ? 'pointer' : '',
          margin: withMargin ? '0.25rem' : '',
        }}
        styleName={`reflection-avatar ${
          reflectionComplete ? 'reflection-complete' : ''
        } ${canDelete ? 'can-delete' : ''}`}
      >
        <Avatar user={user} />
        <AnimatePresence>
          {active && <motion.div styleName="active" {...framerFade} />}
        </AnimatePresence>
        <div styleName="overlay">
          <FontAwesomeIcon icon={canDelete ? faTrash : faCheck} />
        </div>
      </div>
    </Tooltip>
  );
}
